import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function WithTrackerGA4({ children, options = {} }) {
  const location = useLocation();
  const trackPage = (page) => {
    ReactGA.set({ page, ...options }, ['tracker1', 'tracker2']);
    ReactGA.send({
      hitType: 'pageview',
      page,
    });
  };
  useEffect(() => trackPage(location.pathname), [location]);

  return children;
}

export default WithTrackerGA4;
